<template>
	<div class="latency-issues">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>Latency</h2>
		<div :class="`audacity p${part}`">
			<img class="wav" src="@/assets/images/latency.png" alt="wav graph showing latency"/>
		</div>
		<div :class="`flex p${part}`">
			<div>
				<h3>Preventable</h3>
				<ul>
					<li>Buffers and network traffic.</li>
				</ul>
			</div>
			<div :class="`unpreventable p${part}`">
				<h3>Unpreventable</h3>
				<ul>
					<li><code class="inline">ac.currentTime</code>&nbsp;<br>What is time? What is now?</p>
					<li>Recording Latency</li>
					<li>Playback Latency</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import PageParts from "../helpers/page-parts";
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "latency-issues",
		components: {SpeakerNotes},
		mixins: [
			PageParts,
		],
		data() {
			return {
				notes: [
					[
						"Get all buffers and all network traffic set up before starting.",
					],
					[
						"AudioContext().currentTime is the best timer",
						"Is it might be accurate?",
						"Reminds me of relativity.",
						"Unpredictable delay that varies from device to device and from run to run.",
						"Playback latency is impossible to measure because the system says it played a sound.",
						"No way to know that it didn't come out for 40ms.",
						"Bluetooth is variable.",
					],
					[
						"Here's an example of a recording.",
						"Direct oscillator at 1 second.",
						"Started another buffer to play a tick at 1 second.",
						"Point out both recording delay and playback delay.",
					],
				]
			};
		},
	}
</script>

<style lang="scss" scoped>
	.latency-issues {
		text-align: center;
	}

	.unpreventable {
		transition: padding  .6s ease-in-out, max-width .6s ease-in-out;
		white-space:nowrap;
		overflow:hidden;
		code {
			overflow: hidden;
		}
		&.p1 {
			max-width: 0;
			padding-left: 0;
			padding-right: 0;
		}
		&.p2 {
			max-width: 700px;
		}
	}

	.audacity {
		max-height: 0;
		overflow: hidden;
		transition: max-height .5s ease-in-out;
		&.p3 {
			margin-bottom: 100px;
			max-height: 350px;
		}
	}

	.flex {
		& > div {
			text-align: left;
			background-color: $block-background;
			padding: 20px;
		}
	}

	@media screen and (min-width: 490px) {
		.flex {
			display: flex;
			justify-content: space-evenly;
			&.p1 {
				justify-content: center;
			}

			& > div {
				text-align: left;
				background-color: $block-background;
				padding: 20px;
				width: 600px;
				height: 415px;
			}
		}
		.wav {
			width: 80%;
			margin-bottom: 50px;
		}
	}
</style>
